if (!customElements.get('ff-product-grid')) {
  customElements.define('ff-product-grid', class FfProductGrid extends HTMLElement {
  constructor(){
    super();
    this.container = this.querySelector("#ff-product-grid-unvailable");
    this.container && (this.collection = JSON.parse(this.container.dataset.collection).handle);
    this.urlCollection = window.location.href.split(/[?#]/)[0];
    this.splitUrl = null;
    this.collectionTag = null;
    this.getCurrentMarketAndLanguage();
  }

  connectedCallback() {
    (window.innerWidth > 1000 && this.container) && this.filtersSticky();
     if(this.container) {
      this.splitUrl = this.urlCollection.split("collections/");
      this.splitUrl[1] && (this.collectionTag = this.splitUrl[1].split("/"));
      this.collection && this.getProducts(); 
    }
  }

  getCurrentMarketAndLanguage() {
    this.locale = Shopify.locale ? Shopify.locale : 'EN';
	  this.country = Shopify.country ? Shopify.country : 'ES';
    //console.log(this.locale, this.country);
  }
  
  queryProducts(cursor) {
    return `
      query @inContext(country: ${this.country.toUpperCase()}, language: ${this.locale.toUpperCase()})
      {
        collection(handle: "${this.collection}") {
          id
          title
          products(first: 250${cursor ? `, after: "${cursor}"`:``}) {
            nodes {
              id
              title
              onlineStoreUrl
              images(first: 2) {
                nodes {
                  url
                }
              }
              handle
              availableForSale
              tags
              options(first: 250) {
                name
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      }
    `
  };

  async getProducts(cursor) {
    try {
      const result = await fetch(`${window.shopUrl}${window.storeFrontVersion}`, {
        method: 'POST',
        headers: window.headersStoreFront,
        body: this.queryProducts(cursor),
        redirect: 'follow'
      });
  
      const {data: {collection: {products: {nodes, pageInfo: {endCursor, hasNextPage}}}}} = await result.json();
      const tagPosition = this.collectionTag.length - 1;

      nodes.forEach(node => {
         if(this.collectionTag.length == 1) {
            !node.availableForSale &&  this.paintNoAvailable(node);  
          } else if (this.collectionTag.length > 1) {
          (!node.availableForSale && (node.tags.includes(this.collectionTag[tagPosition].toUpperCase()) || 
          node.tags.includes(this.collectionTag[tagPosition].toLowerCase()))) && this.paintNoAvailable(node) 
        }
      });
      hasNextPage && this.getProducts(endCursor);
    } catch(error) {
      console.log('error', error);
    }
  }

  paintNoAvailable(node) {
    //console.log(node);
    this.container.innerHTML += `
    <li class="grid__item ff-sold-out">
      <a href="${node.onlineStoreUrl}">
        <div class="ff-unvailable-background-featured">
          <img src="${node.images.nodes[0].url}" class="ff-image-product-item" width="620" height="770">
          ${node.images.nodes.length > 1 && `<img src="${node.images.nodes[1].url}" class="ff-image-product-item" width="620" height="770">`}
        </div>
      </a>
      <div class="center">
        <h3>
          <a class="ff-product-title" href="${node.onlineStoreUrl}">
            ${node.title}
          </a>
        </h3>
      </div>
      <div class="ff-sold-out-collection center">
        ${window.variantStrings.soldOut}
      </div>
    </li>
    `
  }
   
  filtersSticky = () => {
    const sideMenu = document.querySelector("ff-menu-filter");
    if (!sideMenu) return;
    const generalMenu = document.querySelector(".ff-announcement-menu");
    const filtersSticky = document.querySelector(".facets-container");
    let currentheight = generalMenu.offsetHeight;
    let position = false;
    
    filtersSticky.style.top = `${generalMenu.offsetHeight}px`; 
  
    document.addEventListener("scroll", () => { 

      if(window.pageYOffset < 20 ) {
        filtersSticky.classList.remove("ff-filters-sticky"); 
        position = false;

      } else if (!position) {
        if (generalMenu.offsetHeight <= currentheight ) {
          setTimeout(() => {
            filtersSticky.style.top = `${generalMenu.offsetHeight}px`;  
          }, 500);
        }

        filtersSticky.classList.add("ff-filters-sticky");
        position = true;
      }
      
      if (generalMenu.offsetHeight <= currentheight ) {
        sideMenu.style.top = `${generalMenu.offsetHeight + filtersSticky.offsetHeight}px`;
        filtersSticky.style.top = `${generalMenu.offsetHeight}px`;
      }
    });
  };
  
});
}